import React, { useEffect, useState } from "react";
import styles from "./styles";
import { Grid } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Tax from "../../../images/dropableIcons/New-tax-line.svg";
import DropableLabel from "../../DropableLabel";
import { isMobile } from "react-device-detect";
import CanvasJSReact from '../../../canvasjs.react';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;
const Graph2 = (props) => {
  const {
    classes,
    submitted,
    setAnsweredCorrectly,
    questionAnswer,
    setAnsweredPartialy,
    setAnswers,
    answers,
    step,
    setSubmit,
    selected,
    setSelected,
    governmentRevenue,
    resetStatesFun
  } = props;

  const [onSelect, setOnSelect] = useState(-1);

  const [correctAnswer, setCorrectAnswer] = useState(questionAnswer.answer);
  const [chartData, setChartData] =useState([])

  const [newYLabels, setNewYLabels] =useState([])
  const [newXLabels, setNewXLabels] =useState([])

  // Default formatter (make sure it's a valid function)
  const defaultXLabelFormatter = (e) => (e.value % 5 === 0 ? e.value : '');

  // State for label formatter, initialized with a valid function
  const [xLabelFormatter, setXLabelFormatter] = useState(() => defaultXLabelFormatter);
  const [yLabelFormatter, setYLabelFormatter] = useState(() => defaultXLabelFormatter);

  // Another formatter function example
  const customXLabelFormatter = (e) => (e?.value % 5 === 0 ? e?.value : newXLabels.includes(e?.value) ? e?.value : "");
  const customYLabelFormatter = (e) => (e?.value % 5 === 0 ? e?.value : newYLabels.includes(e?.value) ? e?.value : "");

  // Function to change the label formatter on event
  const changeFormatter = () => {
    setXLabelFormatter(() => customXLabelFormatter);
    setYLabelFormatter(() => customYLabelFormatter);
    setChartData(data)
  };

  let data = [
    {
      type: "line",
      color: '#003e4c',
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 8, y: 16}, {x: 0, y: 0}]
    },
    {
      type: "line",
      color: '#02b1d9',
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{y: 15, x: 0}, {x: 18, y: 6}]
    },
    // pb
    {
      type: "line",
      color: step !== 3 ? '#003e4c' : 'transparent',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 0, y: 14,  markerType: 'none'}, {x: 2, y: 14,  markerType: 'none'}]
    },
    // pb-vertical
    {
      type: "line",
      color: step !== 3 && step !== 4 && step !== 6 ? '#003e4c' : 'transparent',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 2, y: 14,  markerType: 'none'}, {x: 2, y: 12,  markerType: 'none'}]
    },
    // pe
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 0, y: 12,  markerType: 'none'}, {x: 2, y: 12,  markerType: 'none'}]
    },
    // pe-next
    {
      type: "line",
      color: '#003e4c' ,
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 2, y: 12,  markerType: 'none'}, {x: 6, y: 12,  markerType: 'none'}]
    },
    // pe-vertical
    {
      type: "line",
      color: step !== 3 && step !== 4 && step !== 6 ? '#003e4c' : 'transparent',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 2, y: 12,  markerType: 'none'}, {x: 2, y: 4,  markerType: 'none'}]
    },
    // ps
    {
      type: "line",
      color: step !== 3 ? '#003e4c' : 'transparent',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 0, y: 4, markerType: 'none'}, {x: 2, y: 4, markerType: 'none'}]
    },
    // extra new lines
    {
      type: "line",
      color: step < 6 ? '#003e4c' : 'transparent',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 6, y: 0, markerType: 'none'}, {x: 6, y: 12, markerType: 'none'}]
    },
    {
      type: "line",
      color: step !== 3 && step !== 4 && step !== 6 ? '#003e4c' : 'transparent',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 2, y: 4, markerType: 'none'}, {x: 2, y: 0, markerType: 'none'}]
    },  
    {
      type: "bubble",
      indexLabel: "S",
      indexLabelFontFamily: 'Rubik',
      indexLabelFontSize: isMobile ? 18 : 26,
      indexLabelFontColor: '#003e4c',
      indexLabelFontWeight: "bold",
      dataPoints: [{x: 8, y: 14, markerType: 'none'}]
    },
    {
      type: "bubble",
      indexLabel: "D",
      indexLabelFontFamily: 'Rubik',
      indexLabelFontSize: isMobile ? 18 : 26,
      indexLabelFontColor: '#02b1d9',
      indexLabelFontWeight: "bold",
      dataPoints: [{x: 14, y: 7, markerType: 'none'}]
    }
  ]

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    title: {
      text: isMobile ? "" : "",
      fontColor: "#transparent",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: 24,
      // padding: {
      //   top: 10,
      //   bottom: 0,
      // },
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 1,
      gridColor: "#cecece",
      labelFontColor: "#003e4c",
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: 1,
      minimum: 0,
      maximum: 15,
      labelFormatter: xLabelFormatter,
      // labelFormatter: function(e) {
      //   return e.value % 5 === 0 ? e.value : e.value === 2 ? e.value : "";
      // }
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      gridThickness: 1,
      labelFontColor: "#003e4c",
      gridColor: "#cecece",
      interval:  1,
      minimum: 0,
      maximum: 15,
      margin: 10,
      labelFormatter: yLabelFormatter,
      // labelFormatter: function(e) {
      //   return e.value % 5 === 0 ? e.value : e.value === 12 ? e.value : "";
      // }
      // title: " asdas",
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile ? 230 : 400,
    width: isMobile ? 300 : 490,
  }


  const changeBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#a3cfd9";
    }
  };

  const resetBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "";
    }
  };

  const resetStates = () => {
    setSubmit(false)
    setSelected([])
    if(step === 7) {
      data[2].color = "#003e4c"
      data[3].color = "#003e4c"
      data[4].color = "#003e4c"
      data[5].color = "#003e4c"
      data[6].color = "#003e4c"
      data[7].color = "#003e4c"
    }
    if(step === 3) {
      setNewYLabels([12])
      setNewXLabels([6])
    }else if(step >= 4) {
      setNewYLabels([4, 12, 14])
      setNewXLabels([2, 6])
    }
    setChartData(data)
  }

  resetStatesFun(resetStates)

  useEffect(() => {
    setNewYLabels([])
    setNewXLabels([])
    setTimeout(() => {
      setCorrectAnswer(questionAnswer.answer)
      resetStates()
    }, 2)
  }, [questionAnswer.answer, step])

  useEffect(() => {
    changeFormatter()
  }, [newXLabels, newYLabels])


  const markSelected = (triangle) => {
    if (!submitted) {
      setOnSelect(1);
      let temp = selected;
      if (selected.includes(triangle)) {
        const index = temp.indexOf(triangle);
        // if (index > -1) {
        temp.splice(index, 1);
        // }
        // temp.pop(triangle);
        setSelected(temp);
      } else {
        temp.push(triangle);
        setSelected(temp);
      }
      if (
        selected.includes(2) && selected.includes(3)) {
        data[2].color = "#00b1d9"
      }
      if (
        selected.includes(3) && selected.includes(4)) {
        data[4].color = "#00b1d9"
      }
      if (
        selected.includes(4) && selected.includes(5)) {
        data[7].color = "#00b1d9"
      }
      if (selected.includes(6) && selected.includes(7)) {
        data[5].color = "#00b1d9"
      }
      if (
        selected.includes(3) && selected.includes(7)) {
        data[3].color = "#00b1d9"
      }
      if (
        selected.includes(4) && selected.includes(6)) {
        data[6].color = "#00b1d9"
      }
    }
    setChartData(data)
    // console.log("selected", selected)
  };

  useEffect(() => {
    setOnSelect(2);
  }, [onSelect]);

  const notQuiteFun = () => {
    let is_partial = "F";
    selected.map((ans) => {
      if (is_partial || is_partial === "F") {
        is_partial = true;
      }
      if (!questionAnswer.answer.includes(ans)) {
        is_partial = false;
      }
    });
    return is_partial === true ? true : false;
  };

  useEffect(() => {
    console.log("in use effect")
    setChartData(data)
  }, [])

  useEffect(() => {
    let is_true = true;
    questionAnswer.answer.map((ans) => {
      if (!selected.includes(ans)) {
        is_true = false;
      }
    });
    const answer = is_true && selected.length === questionAnswer.answer.length;
    if (submitted && step === 7) {
      let tempAnswer = answers;
      if (answer) {
        if(questionAnswer.index === 2){
          tempAnswer.push(governmentRevenue === questionAnswer.numberAnswer);
        }else{
          tempAnswer.push(true);
        }
        setAnswers(tempAnswer);
        if (
          questionAnswer.answer.includes(2) &&
          questionAnswer.answer.includes(3)
        ) {
          data[2].color = "green"
        }
        if (
          questionAnswer.answer.includes(3) &&
          questionAnswer.answer.includes(7)
        ) {
          data[3].color = "green"
        }
        if (
          questionAnswer.answer.includes(3) &&
          questionAnswer.answer.includes(4)
        ) {
          data[4].color = "green"
        }
        if (
          questionAnswer.answer.includes(4) &&
          questionAnswer.answer.includes(5)
        ) {
          data[7].color = "green"
        }
        if (
          questionAnswer.answer.includes(6) &&
          questionAnswer.answer.includes(7)
        ) {
          data[5].color = "green"
        }
        if (
          questionAnswer.answer.includes(4) &&
          questionAnswer.answer.includes(6)
        ) {
          data[6].color = "green"
        }
        setAnsweredCorrectly(true);
      } else {
        tempAnswer?.push(false);
        setAnswers(tempAnswer);
        let is_partial = false;
        if (selected.length < questionAnswer.answer.length) {
          is_partial = notQuiteFun();
          // selected.map((ans) => {
          //   is_partial = true;
          //   if (!questionAnswer.answer.includes(ans)) {
          //     is_partial = false;
          //   }
          // });
        }
        if (is_partial) {
          setAnsweredPartialy(true);
        } else {
          setAnsweredPartialy(false);
          setAnsweredCorrectly(false);
        }
        if (
          questionAnswer.answer.includes(2) &&
          questionAnswer.answer.includes(3)
        ) {
          data[2].color = "green"
        }
        if (
          questionAnswer.answer.includes(3) &&
          questionAnswer.answer.includes(7)
        ) {
          data[3].color = "green"
        }
        if (
          questionAnswer.answer.includes(3) &&
          questionAnswer.answer.includes(4)
        ) {
          data[4].color = "green"
        }
        if (
          questionAnswer.answer.includes(4) &&
          questionAnswer.answer.includes(5)
        ) {
          data[7].color = "green"
        }
        if (
          questionAnswer.answer.includes(6) &&
          questionAnswer.answer.includes(7)
        ) {
          data[5].color = "green"
        }
        if (
          questionAnswer.answer.includes(4) &&
          questionAnswer.answer.includes(6)
        ) {
          data[6].color = "green"
        }

        // if (selected.includes(2) || selected.includes(3)) {
        if ((selected.includes(2) && !questionAnswer.answer.includes(2)) || (selected.includes(3) && !questionAnswer.answer.includes(3))) {
          // setRedHoriLine1(true);
          data[2].color = "red"
        }
        // if (selected.includes(3) || selected.includes(4)) {
        if ((selected.includes(4) && !questionAnswer.answer.includes(4)) || (selected.includes(3) && !questionAnswer.answer.includes(3))) {
          // setRedHoriLine2(true);
          data[4].color = "red"
        }
        // if (selected.includes(4) || selected.includes(5)) {
        if ((selected.includes(4) && !questionAnswer.answer.includes(4)) || (selected.includes(5) && !questionAnswer.answer.includes(5))) {
          // setRedHoriLine4(true);
          data[7].color = "red"
        }

        // if (selected.includes(6) || selected.includes(7)) {
        if ((selected.includes(6) && !questionAnswer.answer.includes(6)) || (selected.includes(7) && !questionAnswer.answer.includes(7))) {
          // setRedHoriLine3(true);
          data[5].color = "red"
        }

        if ((selected.includes(3) && !questionAnswer.answer.includes(3)) || (selected.includes(7) && !questionAnswer.answer.includes(7))) {
          // setRedVertiLine1(true);
          data[3].color = "red"
        }

        // if (selected.includes(4) || selected.includes(6)) {
        if ((selected.includes(4) && !questionAnswer.answer.includes(4)) || (selected.includes(6) && !questionAnswer.answer.includes(6))) {
          // setRedVertiLine2(true);
          data[6].color = "red"
        }
      }
      setChartData(data)
    }
  }, [submitted]);

  const checkSelection = (triangle) => selected.includes(triangle);

  const demandCurveResponsive = () => {
    return (
      <div className={classes.internationalContainerMajor}>
        {/* <DropableLabel
          aref={aref}
          inAnswer={inAnswer}
          isRight={isRight}
          right={right}
          marginTop={marginTop}
          rotate={rotate}
          label={label}
          isSubmitted={isSubmitted}
          isCorrectLabel={isCorrectLabel}
        /> */}
        {/* {children} */}
        {/* center dot */}
        {step === 3 &&
        <div className={`centerDot ${classes.waveDot}`}></div>
        }
        {/* tax line and two dots */}
        {(step !== 3 && (questionAnswer.index !== 5  || !submitted) )&&
        <img src={Tax} alt="Tax" className="taxLine" style={{  position: "absolute", zIndex: 2, height: isMobile ? "38%" : "50%", left: isMobile ? "19%" : "29%", top: isMobile ? "13.5%" : "13.5%" }}/>
        }
        {(step === 4 ||  step === 5 || step === 6) &&
          <>
            <div className={classes.upperDot}></div>

            <div className={classes.lowerDot}></div>
          </>
        }


        <div className={classes.internationalContainerChild} >
        {(step > 2 || (step === 2 && submitted)) && <h4 className={classes.pLabels}>P</h4> }
        {step > 2 &&
        <>
        <div style={{ display: "flex", flexDirection: "column", position: "absolute", height: "100%", left: isMobile ? -20 : -40, top: isMobile ? 14 : 20 }}>
          <h4 className={classes.labelText} dangerouslySetInnerHTML={{__html: step > 3 ? "P<sub>b</sub>" : "" }}/>
          <h4 className={classes.labelText} style={{ marginTop: isMobile ? 1 : 20 }}  dangerouslySetInnerHTML={{__html: "P<sub>e</sub>" }}/>
          <h4 className={classes.labelText} style={{ marginTop: isMobile ? 77 : 170 }}  dangerouslySetInnerHTML={{__html: step > 3 ? "P<sub>s</sub>" : "" }}/>
        </div>
        <div style={{ display: "flex", position: "absolute", zIndex: 1, bottom: isMobile ? 13 : -30,width: "100%" }}>
          <h4 className={classes.labelText} style={{ marginLeft: isMobile ? 60 : 90 }}  dangerouslySetInnerHTML={{__html: step > 3 ? "Q<sub>t</sub>" :  "" }}/>
          {step === 5 &&
            <h4  className={`centerDot ${classes.labelWaveCircle}`} />
          }
          <h4 className={classes.labelText} style={{ marginLeft:  isMobile ? 50 : 100 }}  dangerouslySetInnerHTML={{__html: "Q<sub>e</sub>" }}/>
        </div></>}
        {(step > 2 || (step === 2 && submitted)) && <h4 className={classes.qLabels}>Q</h4> }

          <CanvasJSChart options = {options} />

           {/* end red lines */}
          {step > 6 &&
          <>
          <div className={classes.shape2Major}>
            <div
              className={classes.shape2Child}
              style={{
                float: "left",
                clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
                shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(2)
                    ? "green"
                    : selected.includes(2)
                    ? "red"
                    : "transparent"
                  : selected.includes(2)
                  ? "#00b1d9"
                  : "transparent",
              }}
              onMouseOut={
                selected.includes(2)
                  ? console.log("hhhh")
                  : !checkSelection(2) && resetBackground
              }
              onMouseOver={
                selected.includes(2)
                  ? console.log("2")
                  : !checkSelection(2) && changeBackground
              }
              onClick={() => markSelected(2)}
            >
            </div>
          </div>

          <div className={classes.shape3Major}>
            <div
              className={classes.shape3Child}
              style={{
                float: "left",
                clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
                shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
                marginTop: 5,
                backgroundColor: submitted
                  ? correctAnswer.includes(3)
                    ? "green"
                    : selected.includes(3)
                    ? "red"
                    : "#transparent"
                  : selected.includes(3)
                  ? "#00b1d9"
                  : "",
              }}
              onMouseOut={
                selected.includes(3)
                  ? console.log("hhhh")
                  : !checkSelection(3) && resetBackground
              }
              onMouseOver={
                selected.includes(3)
                  ? console.log("3")
                  : !checkSelection(3) && changeBackground
              }
              onClick={() => markSelected(3)}
            />
          </div>

          <div className={classes.shape4Major}>
            <div
              className={classes.shape4Child}
              style={{
                float: "left",
                clipPath: "inset(0 0 0 0)",
                shapeOutside: "inset(0 0 0 0)",
                width: "100%",
                marginTop: 3,
                backgroundColor: submitted
                  ? correctAnswer.includes(4)
                    ? "green"
                    : selected.includes(4)
                    ? "red"
                    : ""
                  : selected.includes(4)
                  ? "#00b1d9"
                  : "",
              }}
              onMouseOut={
                selected.includes(4)
                  ? console.log("hhdashh")
                  : !checkSelection(4) && resetBackground
              }
              onMouseOver={
                selected.includes(4)
                  ? console.log("4")
                  : !checkSelection(4) && changeBackground
              }
              onClick={() => markSelected(4)}
            />
          </div>

          <div className={classes.shape5Major}>
            <div
              className={classes.shape5Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(5)
                    ? "green"
                    : selected.includes(5)
                    ? "red"
                    : ""
                  : selected.includes(5)
                  ? "#00b1d9"
                  : "",
              }}
              onMouseOut={
                selected.includes(5)
                  ? console.log("hhhh")
                  : !checkSelection(5) && resetBackground
              }
              onMouseOver={
                selected.includes(5)
                  ? console.log("5")
                  : !checkSelection(5) && changeBackground
              }
              onClick={() => markSelected(5)}
            />
          </div>

          <div className={classes.shape6Major} style={{}}>
            <div
              className={classes.shape6Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(6)
                    ? "green"
                    : selected.includes(6)
                    ? "red"
                    : ""
                  : selected.includes(6)
                  ? "#00b1d9"
                  : "",
              }}
              onMouseOut={
                selected.includes(6)
                  ? console.log("hhhh")
                  : !checkSelection(6) && resetBackground
              }
              onMouseOver={
                selected.includes(6)
                  ? console.log("6")
                  : !checkSelection(6) && changeBackground
              }
              onClick={() => markSelected(6)}
            />
          </div>

          <div className={classes.shape7Major}>
            <div
              className={classes.shape7Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(7)
                    ? "green"
                    : selected.includes(7)
                    ? "red"
                    : ""
                  : selected.includes(7)
                  ? "#00b1d9"
                  : "",
              }}
              onMouseOut={
                selected.includes(7)
                  ? console.log("hhhh")
                  : !checkSelection(7) && resetBackground
              }
              onMouseOver={
                selected.includes(7)
                  ? console.log("7")
                  : !checkSelection(7) && changeBackground
              }
              onClick={() => markSelected(7)}
            />
          </div>
          </>}
        </div>
      </div>
    );
  };

  return <Grid style={{ width: isMobile ? 320 :565 }}>
    {demandCurveResponsive()}
    </Grid>;
};

export default withStyles(styles)(Graph2);
